import { apiPost } from './apiClient';
import { setTsrCustomerToken } from '../auth/tsrCustomerAuth';

export const requestTsrCustomerOtp = async ({ channel, phone, email }) => {
  const body = { channel };
  if (channel === 'phone') {
    body.phone = phone;
  } else {
    body.email = email;
  }
  return apiPost('/tsrfood/customer/request-otp', body);
};

export const verifyTsrCustomerOtp = async ({ channel, phone, email, otp }) => {
  const body = { channel, otp };
  if (channel === 'phone') {
    body.phone = phone;
  } else {
    body.email = email;
  }
  const response = await apiPost('/tsrfood/customer/verify-otp', body);
  if (response?.data?.token) {
    setTsrCustomerToken(response.data.token);
  }
  return response;
};
